<template>
  <div class="search-box">
    <div class="relative w-full">
      <input
        type="text"
        :value="modelValue"
        @input="handleInput"
        @compositionstart="handleCompositionStart"
        @compositionend="handleCompositionEnd"
        :placeholder="placeholder || t('music.search.placeHolder')"
        class="w-full h-10 px-10 rounded-full bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <!-- 搜索图标 -->
      <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
        </svg>
      </div>
      <!-- 取消按钮 -->
      <button 
        v-if="showCancel" 
        @click="$emit('cancel')"
        class="absolute right-6 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
      >
        {{ t('common.cancel') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';
import { ref } from 'vue';

const { t } = useI18n();
const isComposing = ref(false);

defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  showCancel: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'cancel', 'input-complete']);

const handleInput = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  emit('update:modelValue', value);
  
  // 只在非输入法编辑状态下触发 input-complete
  if (!isComposing.value) {
    emit('input-complete', value);
  }
};

const handleCompositionStart = () => {
  isComposing.value = true;
};

const handleCompositionEnd = (event: CompositionEvent) => {
  isComposing.value = false;
  // 在输入法编辑结束时触发 input-complete
  emit('input-complete', (event.target as HTMLInputElement).value);
};
</script>

<style scoped>
.search-box {
  width: 100%;
  padding: 8px 0;
}
</style> 